module.exports = __webpack_public_path__ + "media/images/common/ico-cart-r-rounded-ffe26a271e6efa1452f9cfede6e18f20.svg";